import { render } from "./AttachmentScreen.vue?vue&type=template&id=927412f8"
import script from "./AttachmentScreen.vue?vue&type=script&lang=js"
export * from "./AttachmentScreen.vue?vue&type=script&lang=js"

import "./AttachmentScreen.vue?vue&type=style&index=0&id=927412f8&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__